<template>
  <div style="display: inline-block;" @click="clickOutSide($event)">
    <div
      style="position: relative;"
      @mouseover="popup(true)"
      @mouseout="popup(false)"
      @click="buyClick($event)"
    >
      <a href="javascript:void(0);" class="btns">
        <i class="btns-row">
          <svg
            id="right-stroke-arrow"
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
            aria-labelledby="right-stroke-arrow"
            role="presentation"
            fill="currentColor"
            data-v-0cbb8ced=""
          >
            <g data-v-0cbb8ced="">
              <g data-v-0cbb8ced="">
                <path
                  d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
                  l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
                  c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                ></path>
              </g>
            </g></svg
        ></i>
        <span class="btns-text">{{ text }}</span>
      </a>
      <div v-show="showPop" class="buy-btn-pop">
        <div class="buy-btn-pop-inner">
          <div v-if="jdBuyLink" class="buy-btn-div buy-btn--top">
            <div
              class="buy-btns buy-btn--default"
              @click="openStore(jdBuyLink, 'jd')"
            >
              <a href="javascript:void(0);" class="btns"
                ><i class="btns-row">
                  <svg
                    id="right-stroke-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    aria-labelledby="right-stroke-arrow"
                    role="presentation"
                    fill="currentColor"
                    data-v-0cbb8ced=""
                  >
                    <g data-v-0cbb8ced="">
                      <g data-v-0cbb8ced="">
                        <path
                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
                  l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
                  c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                        ></path>
                      </g>
                    </g></svg
                ></i>
                <span class="btns-text buy-btns-text">京东官方旗舰店</span>
              </a>
            </div>
          </div>
          <div v-if="tmBuyLink" class="buy-btn-div buy-btn--bottom">
            <div
              class="buy-btns buy-btn--default"
              @click="openStore(tmBuyLink, 'tm')"
            >
              <a href="javascript:void(0);" class="btns"
                ><i class="btns-row">
                  <svg
                    id="right-stroke-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    aria-labelledby="right-stroke-arrow"
                    role="presentation"
                    fill="currentColor"
                    data-v-0cbb8ced=""
                  >
                    <g data-v-0cbb8ced="">
                      <g data-v-0cbb8ced="">
                        <path
                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
                  l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
                  c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                        ></path>
                      </g>
                    </g></svg
                ></i>
                <span class="btns-text buy-btns-text">天猫官方旗舰店</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebpImage from './webp-image.vue';
import { pgvEventReport } from '../tcss-report';
function getPurchaseUrl(purchaseUrls, key) {
  const result = purchaseUrls.filter((item) => {
    return item.key === key;
  });
  return (result.length && result[0].url) || '';
}
export default {
  components: {
    WebpImage
  },
  props: {
    text: {
      type: String,
      default: '立即购买'
    },
    urls: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showPop: false,
      JD: {
        key: 'JD',
        name: '京东官方旗舰店'
      },
      TM: {
        key: 'TM',
        name: '天猫官方旗舰店'
      },
      WX_STORE: {
        key: 'WXSTORE',
        name: '微信官方商城'
      }
    };
  },
  computed: {
    jdBuyLink() {
      return getPurchaseUrl(this.urls, this.JD.key);
    },
    wxStoreImgUrl() {
      return getPurchaseUrl(this.urls, this.WX_STORE.key);
    },
    tmBuyLink() {
      return getPurchaseUrl(this.urls, this.TM.key);
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.popup(false);
    });
  },
  methods: {
    buyClick(event) {
      // 阻止弹框
      event.preventDefault();
      event.stopPropagation();
    },
    clickOutSide(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.showPop) {
        this.showPop = false;
      }
    },
    popup(show) {
      this.showPop = show;
    },
    openStore(url, pv) {
      pgvEventReport(`mariocart_coursepack.open_store_${pv}`);
      window.open(url);
    }
  }
};
</script>

<style>
.buy-btn-pop {
  cursor: default;
  position: absolute;
  bottom: 8rem;
  left: 0;
  width: 100%;
  margin-left: 0;
  background-color: #fff;
  -webkit-box-shadow: #b3b3b3 0 0 16px;
  box-shadow: 0 0 16px #b3b3b3;
  -webkit-transition: 0.3s;
  border-radius: 4px;
  pointer-events: auto;
  transition: 0.3s;
  z-index: 20;
}
.buy-btn-pop:before {
  left: 0;
  top: 0;
  width: 105%;
  height: calc(100% + 15px);
  z-index: -2;
  content: '';
  display: inline-block;
  position: absolute;
}
.buy-btn-pop:after {
  width: 0;
  height: 0;
  border-color: #fff transparent transparent;
  border-style: solid;
  border-width: 5px 4px 0;
  left: 50%;
  margin-left: -3px;
}
.buy-btn-pop:after,
.buy-btn-pop:before {
  content: '';
  display: inline-block;
  position: absolute;
}
.buy-btn-div {
  padding: 0 1rem;
  margin-bottom: 2.1rem;
}
.buy-btn-wechat {
  margin-bottom: 2.1rem;
}
.buy-btns-text {
  font-size: 2.6rem;
}
.buy-btn-pop .buy-btns {
  font-size: 2.6rem;
  color: #fff;
  width: 100%;
  /* height: 7rem; */
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #e60013;
  border-radius: 5px;
}
.buy-btn-pop .qrcode-scan {
  text-align: center;
}
.buy-btn-pop-inner {
  margin: 2.3rem 0;
}
@media print, screen and (min-width: 980px) {
  .buy-btn-pop .qrcode-box {
    width: 140px;
    height: 140px;
    margin: 0 auto 10px;
  }
  .oled-buy-btn-pop .qrcode-scan {
    padding: 0 33px;
    margin-bottom: 12px;
  }
}
@media screen and (max-width: 759px) {
  .buy-btn-pop .qrcode-scan {
    padding: 0 20px;
    margin-bottom: 6px;
  }
  .buy-btn-pop .qrcode-box {
    width: 111px;
    height: 111px;
    margin: 0 auto 10px;
  }
  .buy-btn-pop {
    bottom: 12rem;
  }
}
</style>
